/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

// Mobile chrome vh fix
var options = [
  {
    selector: '#hero', // Mandatory, CSS selector
    vh: 160,  // Mandatory, height in vh units
  },
  {
    selector: '#apply',
    vh: 150
  }
];

//var vhFix = new VHChromeFix(options);

// Parallax stuff
var s = skrollr.init({
  skrollrBody: '#content',
  mobileCheck: function() {
    // Force disable mobile version
    return false;
  }
});

// Front page imagesLoaded
/*
var parallax = document.getElementById('parallax');

if (parallax) {
  imagesLoaded(parallax, { background: '.parallax-background' }, function(instance) {
    parallax.className += ' loaded';
  });
}
*/

// Page header imagesLoaded
var header = document.getElementById('site-header');

if (header) {
  imagesLoaded(header, { background: true }, function(instance) {
    header.className += ' loaded';
  });
}

